import { Link } from "react-router-dom";
import Reveal from "@/components/feature/Reveal";
import { quickNavItems } from "@/mocks/treatments";

export default function QuickNav() {
  return (
    <section className="bg-background-50 pb-14 pt-12 md:pb-20 md:pt-16">
      <div className="u-container">
        <Reveal>
          <div className="no-scrollbar flex snap-x gap-px overflow-x-auto border-y border-background-300/80 bg-background-300/80 lg:grid lg:grid-cols-3 lg:overflow-visible">
            {quickNavItems.map((item) => (
              <Link
                key={item.en}
                to={item.href}
                className="group flex w-[78%] shrink-0 snap-start flex-col gap-6 bg-background-50 px-6 py-8 transition-colors hover:bg-background-100 sm:w-[46%] md:px-7 md:py-9 lg:w-auto lg:px-8"
              >
                <div className="flex items-center justify-between">
                  <span className="font-label text-[11px] tracking-[0.25em] text-secondary-600">{item.no}</span>
                  <i
                    className="ri-arrow-right-up-line text-lg text-foreground-400 transition-all group-hover:-translate-y-0.5 group-hover:translate-x-0.5 group-hover:text-accent-700"
                    aria-hidden
                  />
                </div>
                <div>
                  <span className="en-eyebrow block text-[9px] text-foreground-500 md:text-[10px]">{item.en}</span>
                  <span className="mt-2.5 block font-heading text-lg text-foreground-950 md:text-xl">{item.jp}</span>
                </div>
              </Link>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}